import { Accordion, AccordionDetails, AccordionSummary, IconButton, useMediaQuery } from '@material-ui/core'
import React from 'react'
import FlexView from 'react-flexview/lib'
import ExpandMoreIcon from '@material-ui/icons/ExpandMore'
import DeleteIcon from '@material-ui/icons/Delete'
import './ExpansionForm.scss'

export const ExpansionForm = ({ onDelete, deleteable, defaultExpanded, formComponent, accordionTile }) => {
  const isMobile = !useMediaQuery(theme => theme.breakpoints.up('md'))

  const onTrash = e => {
    e.stopPropagation()
    onDelete && onDelete()
  }

  return (
    <FlexView className="full-width">
      <Accordion className="expansion-container full-width" defaultExpanded={defaultExpanded}>
        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
          <FlexView className="space-between full-width">
            <FlexView vAlignContent={'center'}>{accordionTile}</FlexView>
            {!isMobile && (
              <FlexView vAlignContent={'center'}>
                <div className="text-small backbuttongray underline clickable">View / Edit</div>
              </FlexView>
            )}
          </FlexView>
        </AccordionSummary>
        <AccordionDetails>{formComponent}</AccordionDetails>
      </Accordion>
      {deleteable && (
        <FlexView vAlignContent={'center'}>
          {/* <div onClick={onTrash} className='text-small backbuttongray underline clickable'>Delete</div> */}
          <IconButton onClick={onTrash}>
            <DeleteIcon className="backbuttongray" />
          </IconButton>
        </FlexView>
      )}
    </FlexView>
  )
}
